export default "__VITE_ASSET__Cb7QN_V2__"